import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import { MoveLeft, Star } from 'lucide-react';
import QuoteIcon from '../Icons/QuoteIcon';
import UK from "../../assets/Unknow.jpg"
import { useQuery } from '@tanstack/react-query';
import { getReviews } from '../../api/Reviews/GetAllReviews';
import Spinner from '../Shared/Spinner';


const Testimonials = () => {
    const { data: ReviewsResponse, isLoading: isReviewsLoading } = useQuery({
        queryFn: getReviews,
        queryKey: ["reviews"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const reviewsData = ReviewsResponse?.data?.reviewData || [];

    return (
        <div className='container'>
            <div className="relative z-50 space-y-5  sm:pt-20 pt-14 flex sm:flex-row flex-col sm:items-end justify-between">
                <div>
                    <h1 className="sm:text-base text-sm font-semibold text-secondary">Testimonials</h1>
                    <h2 className="md:text-4xl sm:text-3xl text-2xl font-semibold text-textPrimary mx-auto ">What Our Customer Says</h2>
                </div>
                <div className="flex sm:gap-5 gap-2.5 items-center sm:justify-start justify-center">
                    <button className="custom-prev4 hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                        <MoveLeft className="text-secondary group-hover:text-white sm:w-8 w-6" size={32} />
                    </button>
                    <div>
                        <div className="custom-pagination2"></div>
                    </div>
                    <button className="custom-next4 hover:bg-secondary transition-all duration-300 bg-white border border-secondary text-white flex items-center justify-center sm:size-[55px] size-12 rounded-full group">
                        <MoveLeft className="rotate-180 text-secondary group-hover:text-white sm:w-8 w-6" size={32} />
                    </button>
                </div>

            </div>
            {isReviewsLoading ? (
                <div className="min-h-[50vh] flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (

            <div className="relative z-50 md:mt-16 sm:mt-12 mt-10">
                <Swiper
                    grabCursor={true}
                    navigation={{
                        nextEl: ".custom-next4",
                        prevEl: ".custom-prev4",
                    }}
                    loop={true}
                    slidesPerView={3}
                    spaceBetween={30}
                    autoplay={{
                        delay: 500,
                        disableOnInteraction: false,
                    }}
                    modules={[Autoplay, Navigation]}
                    speed={3000}
                    className="mySwiper sm:!pb-24 !pb-[70px]"
                    breakpoints={{
                        0: {
                            slidesPerView: 1.1,
                            spaceBetween: 10,
                        },
                        550: {
                            slidesPerView: 1.6,
                            spaceBetween: 10,
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 12,
                        },
                        768: {
                            slidesPerView: 2.5,
                            spaceBetween: 20,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 25,
                        },
                    }}
                >
                    {reviewsData.map(slide => (
                        <SwiperSlide key={slide.id} className="relative !h-auto">
                            <div className="relative h-full">
                            <div className="bg-secondary lg:px-6 md:px-4 px-2 flex flex-col justify-between rounded-[20px] md:mb-7 mb-5 md:pt-1 pt-1 md:pb-8 h-full pb-3">
                            <div>
                                        <QuoteIcon className='sm:w-20 w-16 mx-auto' />
                                        <p className='text-white text-center text-sm sm:mt-5 mt-2.5  sm:mb-5 font-medium '>{slide.review}</p>
                                    </div>
                                    <div>
                                        <div className='flex gap-2 justify-center mb-3 border-t pt-7 border-[#ffc600]'>
                                        {[...Array(5)].map((_, index) => (
                            <Star 
                                key={index} 
                                size={20} 
                                className='text-[#ffc600]' 
                                fill={index < slide.rating ? '#ffc600' : '#cbd3e3'} 
                            />
                        ))}                                        </div>
                                        <div className='flex sm:gap-3 gap-1.5 justify-center items-center'>
                                            <h1 className='font-semibold sm:text-xl text-lg text-white'>{slide.name}</h1>
                                            {/* <p className='text-[#ffc600] sm:text-sm text-xs'>{slide.position}</p> */}
                                        </div>

                                    </div>
                                </div>
                                <div className='w-full relative'>
                                    <div className='w-full h-0.5 bg-secondary' />
                                    <img src={UK} className="md:size-[70px] size-14  absolute left-1/2 -translate-x-1/2 object-cover rounded-full z-50 top-2.5 -translate-y-1/2" alt="" />
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            )}
        </div>
    )
}

export default Testimonials